import Branch from "../../../components/company/organization/branch"

const BranchPage: React.FC = () => {
    return (
        <Branch />
    )
};

export default BranchPage;